import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the CN UAT environment (`admin.cn-uat.wisesys.info`)
 */
export const cnUatServerConfig: ServerBaseUrl = {
    apiServer: 'https://wise-api.cn-uat.wisesys.info',
    auroraApiServer: 'https://uat.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://l8e0mz5odb.execute-api.us-east-1.amazonaws.com/uat',
    equipment: 'https://services-uat.ca.cn-uat.wisesys.info',
    socketServer: 'wss://socket.cn-uat.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket-uat.ca.cn-uat.wisesys.info',
    auroraServer: '',
    environment: ServerEnvironment.CN_UAT,
    CIEnv: ServerCIEnvironment.CN_UAT,
    vehicleProfile:
        'https://z9fgl5xulh.execute-api.us-east-1.amazonaws.com/uat',
    routePathGeometryServer:
        'https://u0dlfowfi9.execute-api.us-east-1.amazonaws.com/uat',
    configurableWorkflowServer:
        'https://ksjgorzu2k.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer: '' // TODO(CD-112): regional UAT — needs its own dcs-<region> stack (separate Cognito issuer)
};
